import { render, staticRenderFns } from "./documentAddIntent.vue?vue&type=template&id=39f8d96c&scoped=true"
import script from "./documentAddIntent.vue?vue&type=script&lang=js"
export * from "./documentAddIntent.vue?vue&type=script&lang=js"
import style0 from "./documentAddIntent.vue?vue&type=style&index=0&id=39f8d96c&prod&lang=less&scoped=true"
import style1 from "./documentAddIntent.vue?vue&type=style&index=1&id=39f8d96c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f8d96c",
  null
  
)

export default component.exports